import React from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { LibraryPages, getLibraryUrlPrefix } from '@/utils/url';
import ThumborImageService from '@/utils/thumbor-image-service';

export default function LibraryItemTile({ locale, item, lazyImg = true }) {
	const { t } = useTranslation();
	const path = `/${getLibraryUrlPrefix(locale, t, LibraryPages.ITEM)}/${item.slug}`.toLocaleLowerCase();
	const isTool = item.model.type_name === 'tool';
	const bgCssClass = isTool ? 'bg-sky-lightest' : 'bg-pumpkin-lightest';
	const bgBorderClass = isTool
		? 'border-sky-lighter hover:border-sky-light'
		: 'border-pumpkin-lighter hover:border-pumpkin-light';

	const typeName = isTool ? t('gynzy-library.tool') : t('gynzy-library.lesson');

	const thumborServiceInstance = ThumborImageService.getInstance();
	const thumbnailPath = thumborServiceInstance.getThumborUrlForImage(item.model.thumbnail_path, 192, 144);

	return (
		<Link to={path}>
			<div
				className={`h-64 w-56 m-5 p-3 rounded-xl border-4 border-opacity-25 transition-all hover:scale-110 ${bgBorderClass} ${bgCssClass}`}
			>
				<div className="w-48 h-36 bg-white border-white border border-2 rounded-lg">
					<img
						src={thumbnailPath}
						alt={item.model.name}
						className="w-full h-full rounded-lg"
						loading={lazyImg ? 'lazy' : 'eager'}
					/>
				</div>
				<div className="text-xs pt-2.5">{typeName}</div>
				<div className="text-midnight font-semibold line-clamp-2 pt-3">{item.model.name}</div>
			</div>
		</Link>
	);
}
